import { isClientAttachment } from '@entities/attachment/lib';
import { IEventJournalModalSchema } from '@widgets/EventJournal/model/types';

export const submitAdapter = (formData: IEventJournalModalSchema) => {
    const fd = new FormData();

    fd.append('text', formData.description);
    fd.append('date', formData.eventDate);
    fd.append('estimate_id', String(formData.selectEstimates));

    formData.attachments.forEach((a) => {
        if (isClientAttachment(a)) {
            fd.append('new_attachments[]', a.file);
        } else {
            fd.append('included_attachments[]', String(a.id));
        }
    });

    return fd;
};
